export enum Privileges {
    EMPLOYERS = 'PRIV_EMPLOYERS',
    EMPL_BILLING_ACCESS = 'PRIV_EMPL_BILLING_ACCESS',
    REPORTADMIN_IN_BSC = 'PRIV_REPORTADMIN_IN_BSC',
    CUSTOM_ADD = 'PRIV_CUSTOM_ADD',
    CUSTOM = 'PRIV_CUSTOM',
    MEMBER_RESTRICT = 'PRIV_MEMBER_RESTRICT',
    MANAGE_SHIFTED_MEMBERS = 'PRIV_MANAGE_SHIFTED_MEMBERS',
    MEMBERS = 'PRIV_MEMBERS',
    PROVIDER_REPORTS = 'PRIV_PROVIDER_REPORTS',
    PROVIDERS = 'PRIV_PROVIDERS',
    BENEFIT_LOOKUP = 'ROLE_BENEFIT_LOOKUP',
    TPA = 'PRIV_TPA',
    MEMBER_HICNMBI = 'PRIV_MEMBER_HICNMBI',
    TPA_LOGIN = 'PRIV_TPA_LOGIN',
    TPA_SPOOF = 'PRIV_TPA_SPOOF',
    TPA_SEARCH = 'PRIV_TPA_SEARCH',
    TPA_CREATEUSER = 'PRIV_TPA_CREATEUSER',
    RECYCLE_MEMBER_ACCOUNT = 'PRIV_RECYCLE_MEMBER_ACCOUNT',
    FAP = 'PRIV_FAP',
    FAP_VIEW_DATA = 'PRIV_FAP_VIEW_DATA',
    FAP_EDIT_DATA = 'PRIV_FAP_EDIT_DATA',
    FAP_ADD_DATA = 'PRIV_FAP_ADD_DATA',
    FAP_DELETE_DATA = 'PRIV_FAP_DELETE_DATA',
    FAP_REPORTS = 'PRIV_FAP_REPORTS',
    LOCK_TAXID = 'PRIV_LOCK_TAXID',
    OPEN_ADMIN_TOOL = 'PRIV_OPEN_ADMIN_TOOL',
    TPA_EXTERNAL_NOTIFICATIONS = 'PRIV_TPA_EXTERNAL_NOTIFICATIONS',
    TPA_USER_DASHBOARD = 'PRIV_TPA_USER_DASHBOARD',
    TPA_AUTHORIZATION_CLINICAL_NOTES = 'PRIV_TPA_AUTHORIZATION_CLINICAL_NOTES',
    TPA_ACCOUNTING = 'PRIV_TPA_ACCOUNTING',
    ASO = 'PRIV_ASO',
    ACC = 'PRIV_ACC', // MDC-514898 ACC - Accolade
    IH = 'PRIV_IH', // MDC-514898 Added Included Health user type for my profile screen (IH - Included Health).
    CWS_BUS = 'PRIV_CWS_BUS',
    CWS_TECH = 'PRIV_CWS_TECH',
    PRODUCER_SEARCH_PRODUCER = 'PRIV_PRODUCER_SEARCH_PRODUCER',
    PRODUCER_BROKER_CONNECTION = 'PRIV_PRODUCER_BROKER_CONNECTION',
    PRODUCER_DIRECT_DEPOSIT = 'PRIV_PRODUCER_DIRECT_DEPOSIT',
    PRODUCER_MEDICARE = 'PRIV_PRODUCER_MEDICARE',
    PRODUCER_GENERATE_BROKER_REPORTS = 'PRIV_PRODUCER_GENERATE_BROKER_REPORTS',
    SEARCH_PROSPECT = 'PRIV_SEARCH_PROSPECT',
    CCM_MEMBER = 'PRIV_CCM_MEMBER',
    CCM_PROVIDER = 'PRIV_CCM_PROVIDER',
    CCM_PRODUCER = 'PRIV_CCM_PRODUCER',
    CCM_EMPLOYER = 'PRIV_CCM_EMPLOYER',
    CCM_PROSPECT = 'PRIV_CCM_PROSPECT',
    CCM_NONMEMBER = 'PRIV_CCM_NONMEMBER',
    PRODUCER_DIRECT_SALES_AGENT = 'PRIV_PRODUCER_DIRECT_SALES_AGENT',
    PRODUCER_ADMIN = 'PRIV_PRODUCER_ADMIN',
    PRODUCER_NEW_BROKER_ANALYST = 'PRIV_PRODUCER_NEW_BROKER_ANALYST',
    EMPLOYER_SURVEY_REPORT = 'PRIV_EMPLOYER_SURVEY',
    EMPLOYER_MLR_REPORT = 'PRIV_EMPLOYER_MLR_REPORT'
}